const transactionSeriesFY26_27 = [
  {
    _id: "69c3abbdd1120db4c7c51b70",
    id: "912468000061872057",
    name: "Sales Delhi 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872087",
        prefix_string: "FA/26-27/",
        ph_replaced_prefix: "FA/26-27/",
        next_number: "00001",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872071",
        prefix_string: "VP/26-27/",
        ph_replaced_prefix: "VP/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872075",
        prefix_string: "VDN/26-27/",
        ph_replaced_prefix: "VDN/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872073",
        prefix_string: "RET/26-27/",
        ph_replaced_prefix: "RET/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872067",
        prefix_string: "PO/26-27/",
        ph_replaced_prefix: "PO/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872063",
        prefix_string: "CN/26-27/",
        ph_replaced_prefix: "CN/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872061",
        prefix_string: "JOU/26-27/",
        ph_replaced_prefix: "JOU/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872065",
        prefix_string: "CP/26-27/",
        ph_replaced_prefix: "CP/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872085",
        prefix_string: "DC/26-27/",
        ph_replaced_prefix: "DC/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872079",
        prefix_string: "DN/26-27/",
        ph_replaced_prefix: "DN/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872077",
        prefix_string: "BOS/26-27/",
        ph_replaced_prefix: "BOS/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872081",
        prefix_string: "ST/26-27/",
        ph_replaced_prefix: "ST/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872069",
        prefix_string: "SO/26-27/",
        ph_replaced_prefix: "SO/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872083",
        prefix_string: "EST/26-27/",
        ph_replaced_prefix: "EST/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872059",
        prefix_string: "SI/26-27/",
        ph_replaced_prefix: "SI/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Delhi",
        branch_id: "912468000000114901",
        branch_name: "Delhi",
        default_series_id: "912468000040993079",
        vat_reg_no: "07ABDCS8429E1Z8",
        location_id: "912468000000114901",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b71",
    id: "912468000061872093",
    name: "Sales Delhi - Commission26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872123",
        prefix_string: "FA/Com/26-27/",
        ph_replaced_prefix: "FA/Com/26-27/",
        next_number: "00001",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872107",
        prefix_string: "VP/Com/26-27/",
        ph_replaced_prefix: "VP/Com/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872111",
        prefix_string: "VDN/Com/26-27/",
        ph_replaced_prefix: "VDN/Com/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872109",
        prefix_string: "RET/Com/26-27/",
        ph_replaced_prefix: "RET/Com/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872103",
        prefix_string: "PO/Com/26-27/",
        ph_replaced_prefix: "PO/Com/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872099",
        prefix_string: "CN/Com/26-27/",
        ph_replaced_prefix: "CN/Com/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872097",
        prefix_string: "JOU/Com/26-27/",
        ph_replaced_prefix: "JOU/Com/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872101",
        prefix_string: "CP/Com/26-27/",
        ph_replaced_prefix: "CP/Com/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872121",
        prefix_string: "DC/Com/26-27/",
        ph_replaced_prefix: "DC/Com/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872115",
        prefix_string: "DN/Com/26-27/",
        ph_replaced_prefix: "DN/Com/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872113",
        prefix_string: "BOS/Com/26-27/",
        ph_replaced_prefix: "BOS/Com/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872117",
        prefix_string: "ST/Com/26-27/",
        ph_replaced_prefix: "ST/Com/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872105",
        prefix_string: "SO/Com/26-27/",
        ph_replaced_prefix: "SO/Com/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872119",
        prefix_string: "EST/Com/26-27/",
        ph_replaced_prefix: "EST/Com/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872095",
        prefix_string: "SI/Com/26-27/",
        ph_replaced_prefix: "SI/Com/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Delhi",
        branch_id: "912468000000114901",
        branch_name: "Delhi",
        default_series_id: "912468000040993079",
        vat_reg_no: "07ABDCS8429E1Z8",
        location_id: "912468000000114901",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b72",
    id: "912468000061872129",
    name: "Sales Delhi - F&V 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872159",
        prefix_string: "FA/FV/26-27/",
        ph_replaced_prefix: "FA/FV/26-27/",
        next_number: "00001",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872143",
        prefix_string: "VP/FV/26-27/",
        ph_replaced_prefix: "VP/FV/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872147",
        prefix_string: "VDN/FV/26-27/",
        ph_replaced_prefix: "VDN/FV/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872145",
        prefix_string: "RET/FV/26-27/",
        ph_replaced_prefix: "RET/FV/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872139",
        prefix_string: "PO/FV/26-27/",
        ph_replaced_prefix: "PO/FV/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872135",
        prefix_string: "CN/FV/26-27/",
        ph_replaced_prefix: "CN/FV/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872133",
        prefix_string: "JOU/FV/26-27/",
        ph_replaced_prefix: "JOU/FV/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872137",
        prefix_string: "CP/FV/26-27/",
        ph_replaced_prefix: "CP/FV/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872157",
        prefix_string: "DC/FV/26-27/",
        ph_replaced_prefix: "DC/FV/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872151",
        prefix_string: "DN/FV/26-27/",
        ph_replaced_prefix: "DN/FV/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872149",
        prefix_string: "BOS/FV/26-27/",
        ph_replaced_prefix: "BOS/FV/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872153",
        prefix_string: "ST/FV/26-27/",
        ph_replaced_prefix: "ST/FV/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872141",
        prefix_string: "SO/FV/26-27/",
        ph_replaced_prefix: "SO/FV/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872155",
        prefix_string: "EST/FV/26-27/",
        ph_replaced_prefix: "EST/FV/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872131",
        prefix_string: "ST/FV/26-27/",
        ph_replaced_prefix: "ST/FV/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Delhi",
        branch_id: "912468000000114901",
        branch_name: "Delhi",
        default_series_id: "912468000040993079",
        vat_reg_no: "07ABDCS8429E1Z8",
        location_id: "912468000000114901",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b73",
    id: "912468000061872165",
    name: "Sales Delhi - Sugar 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872195",
        prefix_string: "FA/S/26-27/",
        ph_replaced_prefix: "FA/S/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872179",
        prefix_string: "VP/S/26-27/",
        ph_replaced_prefix: "VP/S/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872183",
        prefix_string: "VDN/S/26-27/",
        ph_replaced_prefix: "VDN/S/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872181",
        prefix_string: "RET/S/26-27/",
        ph_replaced_prefix: "RET/S/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872175",
        prefix_string: "PO/S/26-27/",
        ph_replaced_prefix: "PO/S/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872171",
        prefix_string: "CN/S/26-27/",
        ph_replaced_prefix: "CN/S/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872169",
        prefix_string: "JOU/S/26-27/",
        ph_replaced_prefix: "JOU/S/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872173",
        prefix_string: "CP/S/26-27/",
        ph_replaced_prefix: "CP/S/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872193",
        prefix_string: "DC/S/26-27/",
        ph_replaced_prefix: "DC/S/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872187",
        prefix_string: "DN/S/26-27/",
        ph_replaced_prefix: "DN/S/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872185",
        prefix_string: "BOS/S/26-27/",
        ph_replaced_prefix: "BOS/S/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872189",
        prefix_string: "ST/S/26-27/",
        ph_replaced_prefix: "ST/S/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872177",
        prefix_string: "SO/S/26-27/",
        ph_replaced_prefix: "SO/S/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872191",
        prefix_string: "EST/S/26-27/",
        ph_replaced_prefix: "EST/S/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872167",
        prefix_string: "SI/S/26-27/",
        ph_replaced_prefix: "SI/S/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Delhi",
        branch_id: "912468000000114901",
        branch_name: "Delhi",
        default_series_id: "912468000040993079",
        vat_reg_no: "07ABDCS8429E1Z8",
        location_id: "912468000000114901",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b74",
    id: "912468000061872201",
    name: "Sales Delhi-Grain 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872231",
        prefix_string: "FA/G/26-27/",
        ph_replaced_prefix: "FA/G/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872215",
        prefix_string: "VP/G/26-27/",
        ph_replaced_prefix: "VP/G/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872219",
        prefix_string: "VDN/G/26-27/",
        ph_replaced_prefix: "VDN/G/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872217",
        prefix_string: "RET/G/26-27/",
        ph_replaced_prefix: "RET/G/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872211",
        prefix_string: "PO/G/26-27/",
        ph_replaced_prefix: "PO/G/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872207",
        prefix_string: "CN/G/26-27/",
        ph_replaced_prefix: "CN/G/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872205",
        prefix_string: "JOU/G/26-27/",
        ph_replaced_prefix: "JOU/G/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872209",
        prefix_string: "CP/G/26-27/",
        ph_replaced_prefix: "CP/G/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872229",
        prefix_string: "DC/G/26-27/",
        ph_replaced_prefix: "DC/G/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872223",
        prefix_string: "DN/G/26-27/",
        ph_replaced_prefix: "DN/G/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872221",
        prefix_string: "BOS/G/26-27/",
        ph_replaced_prefix: "BOS/G/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872225",
        prefix_string: "ST/G/26-27/",
        ph_replaced_prefix: "ST/G/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872213",
        prefix_string: "SO/G/26-27/",
        ph_replaced_prefix: "SO/G/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872227",
        prefix_string: "EST/G/26-27/",
        ph_replaced_prefix: "EST/G/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872203",
        prefix_string: "SI/G/26-27/",
        ph_replaced_prefix: "SI/G/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Delhi",
        branch_id: "912468000000114901",
        branch_name: "Delhi",
        default_series_id: "912468000040993079",
        vat_reg_no: "07ABDCS8429E1Z8",
        location_id: "912468000000114901",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b75",
    id: "912468000061872237",
    name: "Sale Delhi- Service Fee 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872267",
        prefix_string: "FA/SF/26-27/",
        ph_replaced_prefix: "FA/SF/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872251",
        prefix_string: "VP/SF/26-27/",
        ph_replaced_prefix: "VP/SF/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872255",
        prefix_string: "VDN/SF/26-27/",
        ph_replaced_prefix: "VDN/SF/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872253",
        prefix_string: "RET/SF/26-27/",
        ph_replaced_prefix: "RET/SF/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872247",
        prefix_string: "PO/SF/26-27/",
        ph_replaced_prefix: "PO/SF/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872243",
        prefix_string: "CN/SF/26-27/",
        ph_replaced_prefix: "CN/SF/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872241",
        prefix_string: "JOU/SF/26-27/",
        ph_replaced_prefix: "JOU/SF/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872245",
        prefix_string: "CP/SF/26-27/",
        ph_replaced_prefix: "CP/SF/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872265",
        prefix_string: "DC/SF/26-27/",
        ph_replaced_prefix: "DC/SF/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872259",
        prefix_string: "DN/SF/26-27/",
        ph_replaced_prefix: "DN/SF/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872257",
        prefix_string: "BOS/SF/26-27/",
        ph_replaced_prefix: "BOS/SF/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872261",
        prefix_string: "ST/SF/26-27/",
        ph_replaced_prefix: "ST/SF/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872249",
        prefix_string: "SO/SF/26-27/",
        ph_replaced_prefix: "SO/SF/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872263",
        prefix_string: "EST/SF/26-27/",
        ph_replaced_prefix: "EST/SF/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872239",
        prefix_string: "SI/SF/26-27/",
        ph_replaced_prefix: "SI/SF/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Delhi",
        branch_id: "912468000000114901",
        branch_name: "Delhi",
        default_series_id: "912468000040993079",
        vat_reg_no: "07ABDCS8429E1Z8",
        location_id: "912468000000114901",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b76",
    id: "912468000061872273",
    name: "Sales Haryana 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872303",
        prefix_string: "FAHR/26-27/",
        ph_replaced_prefix: "FAHR/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872287",
        prefix_string: "VPHR/26-27/",
        ph_replaced_prefix: "VPHR/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872291",
        prefix_string: "VDNHR/26-27/",
        ph_replaced_prefix: "VDNHR/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872289",
        prefix_string: "RETHR/26-27/",
        ph_replaced_prefix: "RETHR/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872283",
        prefix_string: "POHR/26-27/",
        ph_replaced_prefix: "POHR/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872279",
        prefix_string: "CNHR/26-27/",
        ph_replaced_prefix: "CNHR/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872277",
        prefix_string: "JOUHR/26-27/",
        ph_replaced_prefix: "JOUHR/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872281",
        prefix_string: "CPHR/26-27/",
        ph_replaced_prefix: "CPHR/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872301",
        prefix_string: "DCHR/26-27/",
        ph_replaced_prefix: "DCHR/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872295",
        prefix_string: "DNHR/26-27/",
        ph_replaced_prefix: "DNHR/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872293",
        prefix_string: "BOSHR/26-27/",
        ph_replaced_prefix: "BOSHR/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872297",
        prefix_string: "STHR/26-27/",
        ph_replaced_prefix: "STHR/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872285",
        prefix_string: "SOHR/26-27/",
        ph_replaced_prefix: "SOHR/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872299",
        prefix_string: "ESTHR/26-27/",
        ph_replaced_prefix: "ESTHR/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872275",
        prefix_string: "SIHR/26-27/",
        ph_replaced_prefix: "SIHR/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Haryana",
        branch_id: "912468000000124010",
        branch_name: "Haryana",
        default_series_id: "912468000041031198",
        vat_reg_no: "06ABDCS8429E1ZA",
        location_id: "912468000000124010",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b77",
    id: "912468000061872309",
    name: "Sales Karnataka 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872339",
        prefix_string: "FAKN/26-27/",
        ph_replaced_prefix: "FAKN/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872323",
        prefix_string: "VPKN/26-27/",
        ph_replaced_prefix: "VPKN/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872327",
        prefix_string: "VDNKN/26-27/",
        ph_replaced_prefix: "VDNKN/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872325",
        prefix_string: "RETKN/26-27/",
        ph_replaced_prefix: "RETKN/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872319",
        prefix_string: "POKN/26-27/",
        ph_replaced_prefix: "POKN/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872315",
        prefix_string: "CNKN/26-27/",
        ph_replaced_prefix: "CNKN/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872313",
        prefix_string: "JOUKN/26-27/",
        ph_replaced_prefix: "JOUKN/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872317",
        prefix_string: "CPKN/26-27/",
        ph_replaced_prefix: "CPKN/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872337",
        prefix_string: "DCKN/26-27/",
        ph_replaced_prefix: "DCKN/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872331",
        prefix_string: "DNKN/26-27/",
        ph_replaced_prefix: "DNKN/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872329",
        prefix_string: "BOSKN/26-27/",
        ph_replaced_prefix: "BOSKN/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872333",
        prefix_string: "STKN/26-27/",
        ph_replaced_prefix: "STKN/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872321",
        prefix_string: "SOKN/26-27/",
        ph_replaced_prefix: "SOKN/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872335",
        prefix_string: "ESTKN/26-27/",
        ph_replaced_prefix: "ESTKN/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872311",
        prefix_string: "SIKN/26-27/",
        ph_replaced_prefix: "SIKN/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Karnataka",
        branch_id: "912468000001732038",
        branch_name: "Karnataka",
        default_series_id: "912468000041031230",
        vat_reg_no: "29ABDCS8429E1Z2",
        location_id: "912468000001732038",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b78",
    id: "912468000061872362",
    name: "Sales Maharashtra 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872392",
        prefix_string: "FAMH/26-27/",
        ph_replaced_prefix: "FAMH/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872376",
        prefix_string: "VPMH/26-27/",
        ph_replaced_prefix: "VPMH/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872380",
        prefix_string: "VDNMH/26-27/",
        ph_replaced_prefix: "VDNMH/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872378",
        prefix_string: "RETMH/26-27/",
        ph_replaced_prefix: "RETMH/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872372",
        prefix_string: "POMH/26-27/",
        ph_replaced_prefix: "POMH/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872368",
        prefix_string: "CNMH/26-27/",
        ph_replaced_prefix: "CNMH/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872366",
        prefix_string: "JOUMH/26-27/",
        ph_replaced_prefix: "JOUMH/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872370",
        prefix_string: "CPMH/26-27/",
        ph_replaced_prefix: "CPMH/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872390",
        prefix_string: "DCMH/26-27/",
        ph_replaced_prefix: "DCMH/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872384",
        prefix_string: "DNMH/26-27/",
        ph_replaced_prefix: "DNMH/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872382",
        prefix_string: "BOSMH/26-27/",
        ph_replaced_prefix: "BOSMH/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872386",
        prefix_string: "STMH/26-27/",
        ph_replaced_prefix: "STMH/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872374",
        prefix_string: "SOMH/26-27/",
        ph_replaced_prefix: "SOMH/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872388",
        prefix_string: "ESTMH/26-27/",
        ph_replaced_prefix: "ESTMH/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872364",
        prefix_string: "SIMH/26-27/",
        ph_replaced_prefix: "SIMH/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Maharashtra",
        branch_id: "912468000012111015",
        branch_name: "Maharashtra",
        default_series_id: "912468000041031262",
        vat_reg_no: "27ABDCS8429E1Z6",
        location_id: "912468000012111015",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b79",
    id: "912468000061872398",
    name: "Sales Madhya Pradesh 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872428",
        prefix_string: "FAMP/26-27/",
        ph_replaced_prefix: "FAMP/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872412",
        prefix_string: "VPMP/26-27/",
        ph_replaced_prefix: "VPMP/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872416",
        prefix_string: "VDNMP/26-27/",
        ph_replaced_prefix: "VDNMP/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872414",
        prefix_string: "RETMP/26-27/",
        ph_replaced_prefix: "RETMP/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872408",
        prefix_string: "POMP/26-27/",
        ph_replaced_prefix: "POMP/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872404",
        prefix_string: "CNMP/26-27/",
        ph_replaced_prefix: "CNMP/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872402",
        prefix_string: "JOUMP/26-27/",
        ph_replaced_prefix: "JOUMP/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872406",
        prefix_string: "CPMP/26-27/",
        ph_replaced_prefix: "CPMP/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872426",
        prefix_string: "DCMP/26-27/",
        ph_replaced_prefix: "DCMP/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872420",
        prefix_string: "DNMP/26-27/",
        ph_replaced_prefix: "DNMP/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872418",
        prefix_string: "BOSMP/26-27/",
        ph_replaced_prefix: "BOSMP/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872422",
        prefix_string: "STMP/26-27/",
        ph_replaced_prefix: "STMP/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872410",
        prefix_string: "SOMP/26-27/",
        ph_replaced_prefix: "SOMP/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872424",
        prefix_string: "ESTMP/26-27/",
        ph_replaced_prefix: "ESTMP/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872400",
        prefix_string: "SIMP/26-27/",
        ph_replaced_prefix: "SIMP/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Madhya Pradesh",
        branch_id: "912468000001540296",
        branch_name: "Madhya Pradesh",
        default_series_id: "912468000041031294",
        vat_reg_no: "23ABDCS8429E1ZE",
        location_id: "912468000001540296",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b7a",
    id: "912468000061872434",
    name: "Sales Punjab 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872464",
        prefix_string: "FAPB/26-27/",
        ph_replaced_prefix: "FAPB/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872448",
        prefix_string: "VPPB/26-27/",
        ph_replaced_prefix: "VPPB/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872452",
        prefix_string: "VDNPB/26-27/",
        ph_replaced_prefix: "VDNPB/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872450",
        prefix_string: "RETPB/26-27/",
        ph_replaced_prefix: "RETPB/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872444",
        prefix_string: "POPB/26-27/",
        ph_replaced_prefix: "POPB/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872440",
        prefix_string: "CNPB/26-27/",
        ph_replaced_prefix: "CNPB/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872438",
        prefix_string: "JOUPB/26-27/",
        ph_replaced_prefix: "JOUPB/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872442",
        prefix_string: "CPPB/26-27/",
        ph_replaced_prefix: "CPPB/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872462",
        prefix_string: "DCPB/26-27/",
        ph_replaced_prefix: "DCPB/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872456",
        prefix_string: "DNPB/26-27/",
        ph_replaced_prefix: "DNPB/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872454",
        prefix_string: "BOSPB/26-27/",
        ph_replaced_prefix: "BOSPB/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872458",
        prefix_string: "STPB/26-27/",
        ph_replaced_prefix: "STPB/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872446",
        prefix_string: "SOPB/26-27/",
        ph_replaced_prefix: "SOPB/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872460",
        prefix_string: "ESTPB/26-27/",
        ph_replaced_prefix: "ESTPB/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872436",
        prefix_string: "SIPB/26-27/",
        ph_replaced_prefix: "SIPB/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Punjab",
        branch_id: "912468000000124051",
        branch_name: "Punjab",
        default_series_id: "912468000041031326",
        vat_reg_no: "03ABDCS8429E1ZG",
        location_id: "912468000000124051",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b7b",
    id: "912468000061872470",
    name: "Sales Rajasthan 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872500",
        prefix_string: "FARJ/26-27/",
        ph_replaced_prefix: "FARJ/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872484",
        prefix_string: "VPRJ/26-27/",
        ph_replaced_prefix: "VPRJ/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872488",
        prefix_string: "VDNRJ/26-27/",
        ph_replaced_prefix: "VDNRJ/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872486",
        prefix_string: "RETRJ/26-27/",
        ph_replaced_prefix: "RETRJ/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872480",
        prefix_string: "PORJ/26-27/",
        ph_replaced_prefix: "PORJ/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872476",
        prefix_string: "CNRJ/26-27/",
        ph_replaced_prefix: "CNRJ/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872474",
        prefix_string: "JOURJ/26-27/",
        ph_replaced_prefix: "JOURJ/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872478",
        prefix_string: "CPRJ/26-27/",
        ph_replaced_prefix: "CPRJ/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872498",
        prefix_string: "DCRJ/26-27/",
        ph_replaced_prefix: "DCRJ/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872492",
        prefix_string: "DNRJ/26-27/",
        ph_replaced_prefix: "DNRJ/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872490",
        prefix_string: "BOSRJ/26-27/",
        ph_replaced_prefix: "BOSRJ/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872494",
        prefix_string: "STRJ/26-27/",
        ph_replaced_prefix: "STRJ/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872482",
        prefix_string: "SORJ/26-27/",
        ph_replaced_prefix: "SORJ/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872496",
        prefix_string: "ESTRJ/26-27/",
        ph_replaced_prefix: "ESTRJ/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872472",
        prefix_string: "SIRJ/26-27/",
        ph_replaced_prefix: "SIRJ/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Rajasthan",
        branch_id: "912468000000124021",
        branch_name: "Rajasthan",
        default_series_id: "912468000041031358",
        vat_reg_no: "08ABDCS8429E1Z6",
        location_id: "912468000000124021",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b7c",
    id: "912468000061872506",
    name: "Sales Uttar Pradesh 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872536",
        prefix_string: "FAUP/26-27/",
        ph_replaced_prefix: "FAUP/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872520",
        prefix_string: "VPUP/26-27/",
        ph_replaced_prefix: "VPUP/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872524",
        prefix_string: "VDNUP/26-27/",
        ph_replaced_prefix: "VDNUP/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872522",
        prefix_string: "RETUP/26-27/",
        ph_replaced_prefix: "RETUP/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872516",
        prefix_string: "POUP/26-27/",
        ph_replaced_prefix: "POUP/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872512",
        prefix_string: "CNUP/26-27/",
        ph_replaced_prefix: "CNUP/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872510",
        prefix_string: "JOUUP/26-27/",
        ph_replaced_prefix: "JOUUP/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872514",
        prefix_string: "CPUP/26-27/",
        ph_replaced_prefix: "CPUP/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872534",
        prefix_string: "DCUP/26-27/",
        ph_replaced_prefix: "DCUP/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872528",
        prefix_string: "DNUP/26-27/",
        ph_replaced_prefix: "DNUP/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872526",
        prefix_string: "BOSUP/26-27/",
        ph_replaced_prefix: "BOSUP/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872530",
        prefix_string: "STUP/26-27/",
        ph_replaced_prefix: "STUP/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872518",
        prefix_string: "SOUP/26-27/",
        ph_replaced_prefix: "SOUP/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872532",
        prefix_string: "ESTUP/26-27/",
        ph_replaced_prefix: "ESTUP/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872508",
        prefix_string: "SIUP/26-27/",
        ph_replaced_prefix: "SIUP/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Uttar Pradesh",
        branch_id: "912468000000124040",
        branch_name: "Uttar Pradesh",
        default_series_id: "912468000041031422",
        vat_reg_no: "09ABDCS8429E1Z4",
        location_id: "912468000000124040",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b7d",
    id: "912468000061872542",
    name: "Sales Uttar Pradesh - Sugar 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872572",
        prefix_string: "FAUP/S/26-27/",
        ph_replaced_prefix: "FAUP/S/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872556",
        prefix_string: "VPUP/S/26-27/",
        ph_replaced_prefix: "VPUP/S/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872560",
        prefix_string: "VDNUP/S/26-27/",
        ph_replaced_prefix: "VDNUP/S/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872558",
        prefix_string: "RETUP/S/26-27/",
        ph_replaced_prefix: "RETUP/S/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872552",
        prefix_string: "POUP/S/26-27/",
        ph_replaced_prefix: "POUP/S/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872548",
        prefix_string: "CNUP/S/26-27/",
        ph_replaced_prefix: "CNUP/S/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872546",
        prefix_string: "JOUUP/S/26-27/",
        ph_replaced_prefix: "JOUUP/S/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872550",
        prefix_string: "CPUP/S/26-27/",
        ph_replaced_prefix: "CPUP/S/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872570",
        prefix_string: "DCUP/S/26-27/",
        ph_replaced_prefix: "DCUP/S/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872564",
        prefix_string: "DNUP/S/26-27/",
        ph_replaced_prefix: "DNUP/S/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872562",
        prefix_string: "BOSUP/S/26-27/",
        ph_replaced_prefix: "BOSUP/S/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872566",
        prefix_string: "STUP/S/26-27/",
        ph_replaced_prefix: "STUP/S/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872554",
        prefix_string: "SOUP/S/26-27/",
        ph_replaced_prefix: "SOUP/S/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872568",
        prefix_string: "ESTUP/S/26-27/",
        ph_replaced_prefix: "ESTUP/S/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872544",
        prefix_string: "SIUP/S/26-27/",
        ph_replaced_prefix: "SIUP/S/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Uttar Pradesh",
        branch_id: "912468000000124040",
        branch_name: "Uttar Pradesh",
        default_series_id: "912468000041031422",
        vat_reg_no: "09ABDCS8429E1Z4",
        location_id: "912468000000124040",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b7e",
    id: "912468000061872578",
    name: "Sales Bihar 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872608",
        prefix_string: "FABR/26-27/",
        ph_replaced_prefix: "FABR/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872592",
        prefix_string: "VPBR/26-27/",
        ph_replaced_prefix: "VPBR/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872596",
        prefix_string: "VDNBR/26-27/",
        ph_replaced_prefix: "VDNBR/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872594",
        prefix_string: "RETBR/26-27/",
        ph_replaced_prefix: "RETBR/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872588",
        prefix_string: "POBR/26-27/",
        ph_replaced_prefix: "POBR/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872584",
        prefix_string: "CNBR/26-27/",
        ph_replaced_prefix: "CNBR/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872582",
        prefix_string: "JOUBR/26-27/",
        ph_replaced_prefix: "JOUBR/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872586",
        prefix_string: "CPBR/26-27/",
        ph_replaced_prefix: "CPBR/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872606",
        prefix_string: "DCBR/26-27/",
        ph_replaced_prefix: "DCBR/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872600",
        prefix_string: "DNBR/26-27/",
        ph_replaced_prefix: "DNBR/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872598",
        prefix_string: "BOSBR/26-27/",
        ph_replaced_prefix: "BOSBR/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872602",
        prefix_string: "STBR/26-27/",
        ph_replaced_prefix: "STBR/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872590",
        prefix_string: "SOBR/26-27/",
        ph_replaced_prefix: "SOBR/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872604",
        prefix_string: "ESTBR/26-27/",
        ph_replaced_prefix: "ESTBR/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872580",
        prefix_string: "SIBR/26-27/",
        ph_replaced_prefix: "SIBR/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Bihar",
        branch_id: "912468000061033056",
        branch_name: "Bihar",
        default_series_id: "912468000060901414",
        vat_reg_no: "10ABDCS8429E1ZL",
        location_id: "912468000061033056",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b7f",
    id: "912468000061872614",
    name: "Haryana-ISD 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872644",
        prefix_string: "FA/ISD/26-27/",
        ph_replaced_prefix: "FA/ISD/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872628",
        prefix_string: "VP/ISD/26-27/",
        ph_replaced_prefix: "VP/ISD/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872632",
        prefix_string: "VDN/ISD/26-27/",
        ph_replaced_prefix: "VDN/ISD/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872630",
        prefix_string: "RET/ISD/26-27/",
        ph_replaced_prefix: "RET/ISD/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872624",
        prefix_string: "PO/ISD/26-27/",
        ph_replaced_prefix: "PO/ISD/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872620",
        prefix_string: "CN/ISD/26-27/",
        ph_replaced_prefix: "CN/ISD/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872618",
        prefix_string: "JOU/ISD/26-27/",
        ph_replaced_prefix: "JOU/ISD/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872622",
        prefix_string: "CP/ISD/26-27/",
        ph_replaced_prefix: "CP/ISD/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872642",
        prefix_string: "DC/ISD/26-27/",
        ph_replaced_prefix: "DC/ISD/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872636",
        prefix_string: "DN/ISD/26-27/",
        ph_replaced_prefix: "DN/ISD/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872634",
        prefix_string: "BOS/ISD/26-27/",
        ph_replaced_prefix: "BOS/ISD/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872638",
        prefix_string: "ST/ISD/26-27/",
        ph_replaced_prefix: "ST/ISD/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872626",
        prefix_string: "SO/ISD/26-27/",
        ph_replaced_prefix: "SO/ISD/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872640",
        prefix_string: "EST/ISD/26-27/",
        ph_replaced_prefix: "EST/ISD/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872616",
        prefix_string: "SI/ISD/26-27/",
        ph_replaced_prefix: "SI/ISD/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Haryana - ISD",
        branch_id: "912468000044034525",
        branch_name: "Haryana - ISD",
        default_series_id: "912468000041031198",
        vat_reg_no: "06ABDCS8429E2Z9",
        location_id: "912468000044034525",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b80",
    id: "912468000061872650",
    name: "Delhi Other 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872680",
        prefix_string: "FA/OTH/26-27/",
        ph_replaced_prefix: "FA/OTH/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872664",
        prefix_string: "VP/OTH/26-27/",
        ph_replaced_prefix: "VP/OTH/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872668",
        prefix_string: "VDN/OTH/26-27/",
        ph_replaced_prefix: "VDN/OTH/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872666",
        prefix_string: "RET/OTH/26-27/",
        ph_replaced_prefix: "RET/OTH/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872660",
        prefix_string: "PO/OTH/26-27/",
        ph_replaced_prefix: "PO/OTH/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872656",
        prefix_string: "CN/OTH/26-27/",
        ph_replaced_prefix: "CN/OTH/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872654",
        prefix_string: "JOU/OTH/26-27/",
        ph_replaced_prefix: "JOU/OTH/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872658",
        prefix_string: "CP/OTH/26-27/",
        ph_replaced_prefix: "CP/OTH/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872678",
        prefix_string: "DC/OTH/26-27/",
        ph_replaced_prefix: "DC/OTH/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872672",
        prefix_string: "DN/OTH/26-27/",
        ph_replaced_prefix: "DN/OTH/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872670",
        prefix_string: "BOS/OTH/26-27/",
        ph_replaced_prefix: "BOS/OTH/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872674",
        prefix_string: "ST/OTH/26-27/",
        ph_replaced_prefix: "ST/OTH/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872662",
        prefix_string: "SO/OTH/26-27/",
        ph_replaced_prefix: "SO/OTH/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872676",
        prefix_string: "EST/OTH/26-27/",
        ph_replaced_prefix: "EST/OTH/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872652",
        prefix_string: "SI/OTH/26-27/",
        ph_replaced_prefix: "SI/OTH/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Delhi",
        branch_id: "912468000000114901",
        branch_name: "Delhi",
        default_series_id: "912468000040993079",
        vat_reg_no: "07ABDCS8429E1Z8",
        location_id: "912468000000114901",
      },
    ],
  },
  {
    _id: "69c3abbdd1120db4c7c51b81",
    id: "912468000061872686",
    name: "Delhi TDS 26",
    autonumbergenerations: [
      {
        autonumbergeneration_id: "912468000061872716",
        prefix_string: "FA/TDS/26-27/",
        ph_replaced_prefix: "FA/TDS/26-27/",
        next_number: "01",
        entity_type: "fixed_asset",
        entity_type_formatted: "Fixed Asset",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872700",
        prefix_string: "VP/TDS/26-27/",
        ph_replaced_prefix: "VP/TDS/26-27/",
        next_number: "01",
        entity_type: "vendor_payment",
        entity_type_formatted: "Vendor Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872704",
        prefix_string: "VDN/TDS/26-27/",
        ph_replaced_prefix: "VDN/TDS/26-27/",
        next_number: "01",
        entity_type: "vendor_credit",
        entity_type_formatted: "Vendor Credits",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872702",
        prefix_string: "RET/TDS/26-27/",
        ph_replaced_prefix: "RET/TDS/26-27/",
        next_number: "01",
        entity_type: "retainer_invoice",
        entity_type_formatted: "Retainer Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872696",
        prefix_string: "PO/TDS/26-27/",
        ph_replaced_prefix: "PO/TDS/26-27/",
        next_number: "01",
        entity_type: "purchaseorder",
        entity_type_formatted: "Purchase Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872692",
        prefix_string: "CN/TDS/26-27/",
        ph_replaced_prefix: "CN/TDS/26-27/",
        next_number: "01",
        entity_type: "creditnote",
        entity_type_formatted: "Credit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872690",
        prefix_string: "JOU/TDS/26-27/",
        ph_replaced_prefix: "JOU/TDS/26-27/",
        next_number: "01",
        entity_type: "journal",
        entity_type_formatted: "Journal",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872694",
        prefix_string: "CP/TDS/26-27/",
        ph_replaced_prefix: "CP/TDS/26-27/",
        next_number: "01",
        entity_type: "customer_payment",
        entity_type_formatted: "Customer Payment",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872714",
        prefix_string: "DC/TDS/26-27/",
        ph_replaced_prefix: "DC/TDS/26-27/",
        next_number: "01",
        entity_type: "deliverychallan",
        entity_type_formatted: "Delivery Challan",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872708",
        prefix_string: "DN/TDS/26-27/",
        ph_replaced_prefix: "DN/TDS/26-27/",
        next_number: "01",
        entity_type: "debit_note",
        entity_type_formatted: "Debit Note",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872706",
        prefix_string: "BOS/TDS/26-27/",
        ph_replaced_prefix: "BOS/TDS/26-27/",
        next_number: "01",
        entity_type: "bill_of_supply",
        entity_type_formatted: "Bill Of Supply",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872710",
        prefix_string: "ST/TDS/26-27/",
        ph_replaced_prefix: "ST/TDS/26-27/",
        next_number: "01",
        entity_type: "invoice",
        entity_type_formatted: "Invoice",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872698",
        prefix_string: "SO/TDS/26-27/",
        ph_replaced_prefix: "SO/TDS/26-27/",
        next_number: "01",
        entity_type: "salesorder",
        entity_type_formatted: "Sales Order",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872712",
        prefix_string: "EST/TDS/26-27/",
        ph_replaced_prefix: "EST/TDS/26-27/",
        next_number: "01",
        entity_type: "estimate",
        entity_type_formatted: "Estimate",
        reset_frequency: "none",
      },
      {
        autonumbergeneration_id: "912468000061872688",
        prefix_string: "SI/TDS/26-27/",
        ph_replaced_prefix: "SI/TDS/26-27/",
        next_number: "01",
        entity_type: "self_invoice",
        entity_type_formatted: "Self-Invoice",
        reset_frequency: "none",
      },
    ],
    associated_branches: [
      {
        location_name: "Delhi",
        branch_id: "912468000000114901",
        branch_name: "Delhi",
        default_series_id: "912468000040993079",
        vat_reg_no: "07ABDCS8429E1Z8",
        location_id: "912468000000114901",
      },
    ],
  },
];
export const transactionSeries = [...transactionSeriesFY26_27];
